import Dropzone from "react-dropzone"

const CustomDropzone = ({ children, multipleUpload, acceptedFiles, onDrop }: any) => {
  const style: any = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px 30px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#b9b9b9",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#555555",
    outline: "none",
    transition: "border .24s ease-in-out",
    minHeight: "100px",
    minWidth: "350px",
    margin: "auto",
    textAlign: "center",
    fontSize: "14px",
    fontFamily: "roboto-regular",
    justifyContent: "center",
    cursor: 'pointer'
  }
  return (
    <Dropzone multiple={multipleUpload} accept={acceptedFiles} onDrop={acceptedFiles => onDrop(acceptedFiles)}>
      {({ getRootProps, getInputProps }) => (
        <div {...getRootProps({ style })} className="pointer">
          <input {...getInputProps()} />
          {children}
        </div>
      )}
    </Dropzone>
  )
}

export default CustomDropzone